import { groupBy, isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type ITabDetail from '@components/RatingTable/components/ProductPopup/interfaces/ITabDetail';

import { useProductConfig } from '../../../../../../store/hooks/productPopupInfo';

export const useCarouselProperties = (product: IProduct, config: ITabDetail) => {
  const [activeKey, setActiveKey] = useState('');

  const vitrinsConfig = useProductConfig();
  const tableRows: IProduct[] = Object.values(product[config.carousel.property]);

  const properties = groupBy(tableRows, config.carousel.groupBy);

  const groupKeys = useMemo(
    () =>
      !isEmpty(properties)
        ? vitrinsConfig.dictionaries[config.carousel.groupByLabels || config.carousel.groupBy]?.reduce((acc, curr) => {
          const value = properties[curr.value];

          if (value) {
            return [...acc, curr];
          }

          return acc;
        }, [])
        : [],
    [properties, config, vitrinsConfig],
  );

  useEffect(() => {
    if (!activeKey) {
      setActiveKey(groupKeys[0]?.value);
    }
  }, [groupKeys, activeKey]);

  const activeItems = useMemo(() => properties[activeKey] || [], [properties, activeKey]);

  const resultItems = useMemo<IProduct[]>(
    () =>
      config.carousel.sortByDataSource
        ? vitrinsConfig.dictionaries[config.carousel.sortByDataSource.dataSource]?.reduce((acc, curr) => {
        const items = activeItems.filter((item) => item[config.carousel.sortByDataSource.property] === curr.value);
        if (items.length) {
          return [...acc, ...items];
        }
        return acc;
      }, []) || []
        : activeItems,
    [config, activeItems, vitrinsConfig],
  );

  return {
    items: resultItems,
    groupKeys: groupKeys || [],
    setActiveKey,
    activeKey,
  };
};
